//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './IssueClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetIssueIssueQueryParameters = {
  id: number;
};

export type PatchIssueIssueMutationParameters = {
  subject?: string | null | undefined ; 
  topic?: string | null | undefined ; 
  topicAdditional?: string | null | undefined ; 
  description?: string | null | undefined ; 
  resultId?: number | null | undefined ; 
  fieldId?: string | null | undefined ; 
  stepName?: string | null | undefined ; 
  fieldDescription?: string | null | undefined ; 
  deadlineAt?: Date | undefined ; 
  linkedPatientUniqId?: string | null | undefined ; 
  newFiles?: Types.FileParameter[] | null | undefined ; 
  filesToDelete?: string[] | null | undefined ; 
  recommendedAction?: string | undefined ; 
};

export type GetIssuesForStudyIssueQueryParameters = {
  studyId: number;
  patientUniqId?: string | null | null;
  patientUniqIds?: string[] | null | null;
  state?: Types.IssuesStateEnum | null | null;
  subjectList?: string[] | null | null;
  patientGroupIds?: number[] | null | null;
  isNew?: boolean | null | null;
  offset?: number | null | null;
  limit?: number | null | null;
  sortBy?: string | null | null;
  sortOrder?: Types.SortOrder | null;
};

export type GetIssuesGroupedByPatientsIssueQueryParameters = {
  studyId: number;
  patientUniqId?: string | null | null;
  patientUniqIds?: string[] | null | null;
  state?: Types.IssuesStateEnum | null | null;
  subjectList?: string[] | null | null;
  patientGroupIds?: number[] | null | null;
  isNew?: boolean | null | null;
  offset?: number | null | null;
  limit?: number | null | null;
  sortBy?: string | null | null;
  sortOrder?: Types.SortOrder | null;
};

export type AddIssueIssueMutationParameters = {
  subject?: string | undefined ; 
  topic?: string | undefined ; 
  topicAdditional?: string | null | undefined ; 
  description?: string | undefined ; 
  resultId?: number | null | undefined ; 
  fieldId?: string | null | undefined ; 
  stepName?: string | null | undefined ; 
  fieldDescription?: string | null | undefined ; 
  deadlineAt?: Date | undefined ; 
  linkedPatientUniqId?: string | null | undefined ; 
  files?: Types.FileParameter[] | null | undefined ; 
  recommendedAction?: string | undefined ; 
};

export type GetIssueHistoryIssueQueryParameters = {
  id: number;
};

export type GetIssueCommentsIssueQueryParameters = {
  id: number;
};

    
export function getIssueUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/issues/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getIssueDefaultOptions: UseQueryOptions<Types.IssueDto, unknown, Types.IssueDto> = {
  queryFn: __getIssue,
};
export function getGetIssueDefaultOptions(): UseQueryOptions<Types.IssueDto, unknown, Types.IssueDto> {
  return getIssueDefaultOptions;
};
export function setGetIssueDefaultOptions(options: UseQueryOptions<Types.IssueDto, unknown, Types.IssueDto>) {
  getIssueDefaultOptions = options;
}

export function getIssueQueryKey(id: number): QueryKey;
export function getIssueQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetIssueIssueQueryParameters;

    return trimArrayEnd([
        'IssueClient',
        'getIssue',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'IssueClient',
        'getIssue',
        ...params
      ]);
  }
}
function __getIssue(context: QueryFunctionContext) {
  return Client.getIssue(
      context.queryKey[2] as number    );
}

export function useGetIssueQuery<TSelectData = Types.IssueDto, TError = unknown>(dto: GetIssueIssueQueryParameters, options?: UseQueryOptions<Types.IssueDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets issue by ID
 */
export function useGetIssueQuery<TSelectData = Types.IssueDto, TError = unknown>(id: number, options?: UseQueryOptions<Types.IssueDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetIssueQuery<TSelectData = Types.IssueDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.IssueDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetIssueIssueQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.IssueDto, TError, TSelectData>({
    queryFn: __getIssue,
    queryKey: getIssueQueryKey(id),
    ...getIssueDefaultOptions as unknown as UseQueryOptions<Types.IssueDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Gets issue by ID
 */
export function setGetIssueData(queryClient: QueryClient, updater: (data: Types.IssueDto | undefined) => Types.IssueDto, id: number) {
  queryClient.setQueryData(getIssueQueryKey(id),
    updater
  );
}

/**
 * Gets issue by ID
 */
export function setGetIssueDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.IssueDto | undefined) => Types.IssueDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function removeIssueUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/issues/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeIssueMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'IssueClient',
      'removeIssue',
      id as any,
    ]);
}

/**
 * Remove issue by ID
 */
export function useRemoveIssueMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeIssueMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.removeIssue(id), {...options, mutationKey: key});
}
  
    
export function patchIssueUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/issues/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchIssueMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'IssueClient',
      'patchIssue',
      id as any,
    ]);
}

/**
 * Update existed issue
 * @param subject (optional) 
 * @param topic (optional) 
 * @param topicAdditional (optional) 
 * @param description (optional) 
 * @param resultId (optional) 
 * @param fieldId (optional) 
 * @param stepName (optional) 
 * @param fieldDescription (optional) 
 * @param deadlineAt (optional) 
 * @param linkedPatientUniqId (optional) 
 * @param newFiles (optional) 
 * @param filesToDelete (optional) 
 * @param recommendedAction (optional) 
 */
export function usePatchIssueMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.IssueDto, unknown, PatchIssueIssueMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.IssueDto, unknown, PatchIssueIssueMutationParameters, TContext> {
  const key = patchIssueMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((patchIssueIssueMutationParameters: PatchIssueIssueMutationParameters) => Client.patchIssue(id, patchIssueIssueMutationParameters.subject, patchIssueIssueMutationParameters.topic, patchIssueIssueMutationParameters.topicAdditional, patchIssueIssueMutationParameters.description, patchIssueIssueMutationParameters.resultId, patchIssueIssueMutationParameters.fieldId, patchIssueIssueMutationParameters.stepName, patchIssueIssueMutationParameters.fieldDescription, patchIssueIssueMutationParameters.deadlineAt, patchIssueIssueMutationParameters.linkedPatientUniqId, patchIssueIssueMutationParameters.newFiles, patchIssueIssueMutationParameters.filesToDelete, patchIssueIssueMutationParameters.recommendedAction), {...options, mutationKey: key});
}
  
    
export function getIssuesForStudyUrl(studyId: number, patientUniqId?: string | null | undefined, patientUniqIds?: string[] | null | undefined, state?: Types.IssuesStateEnum | null | undefined, subjectList?: string[] | null | undefined, patientGroupIds?: number[] | null | undefined, isNew?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/issues/forStudy?";
  if (studyId === undefined || studyId === null)
    throw new Error("The parameter 'studyId' must be defined and cannot be null.");
  else
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
if (patientUniqId !== undefined && patientUniqId !== null)
    url_ += "PatientUniqId=" + encodeURIComponent("" + patientUniqId) + "&";
if (patientUniqIds !== undefined && patientUniqIds !== null)
    patientUniqIds && patientUniqIds.forEach(item => { url_ += "PatientUniqIds=" + encodeURIComponent("" + item) + "&"; });
if (state !== undefined && state !== null)
    url_ += "State=" + encodeURIComponent("" + state) + "&";
if (subjectList !== undefined && subjectList !== null)
    subjectList && subjectList.forEach(item => { url_ += "SubjectList=" + encodeURIComponent("" + item) + "&"; });
if (patientGroupIds !== undefined && patientGroupIds !== null)
    patientGroupIds && patientGroupIds.forEach(item => { url_ += "PatientGroupIds=" + encodeURIComponent("" + item) + "&"; });
if (isNew !== undefined && isNew !== null)
    url_ += "IsNew=" + encodeURIComponent("" + isNew) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getIssuesForStudyDefaultOptions: UseQueryOptions<Types.PagedResultOfIssueDto, unknown, Types.PagedResultOfIssueDto> = {
  queryFn: __getIssuesForStudy,
};
export function getGetIssuesForStudyDefaultOptions(): UseQueryOptions<Types.PagedResultOfIssueDto, unknown, Types.PagedResultOfIssueDto> {
  return getIssuesForStudyDefaultOptions;
};
export function setGetIssuesForStudyDefaultOptions(options: UseQueryOptions<Types.PagedResultOfIssueDto, unknown, Types.PagedResultOfIssueDto>) {
  getIssuesForStudyDefaultOptions = options;
}

export function getIssuesForStudyQueryKey(dto: GetIssuesForStudyIssueQueryParameters): QueryKey;
export function getIssuesForStudyQueryKey(studyId: number, patientUniqId?: string | null | undefined, patientUniqIds?: string[] | null | undefined, state?: Types.IssuesStateEnum | null | undefined, subjectList?: string[] | null | undefined, patientGroupIds?: number[] | null | undefined, isNew?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getIssuesForStudyQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId, patientUniqId, patientUniqIds, state, subjectList, patientGroupIds, isNew, offset, limit, sortBy, sortOrder,  } = params[0] as GetIssuesForStudyIssueQueryParameters;

    return trimArrayEnd([
        'IssueClient',
        'getIssuesForStudy',
        studyId as any,
        patientUniqId as any,
        patientUniqIds as any,
        state as any,
        subjectList as any,
        patientGroupIds as any,
        isNew as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'IssueClient',
        'getIssuesForStudy',
        ...params
      ]);
  }
}
function __getIssuesForStudy(context: QueryFunctionContext) {
  return Client.getIssuesForStudy(
      context.queryKey[2] as number,       context.queryKey[3] as string | null | undefined,       context.queryKey[4] as string[] | null | undefined,       context.queryKey[5] as Types.IssuesStateEnum | null | undefined,       context.queryKey[6] as string[] | null | undefined,       context.queryKey[7] as number[] | null | undefined,       context.queryKey[8] as boolean | null | undefined,       context.queryKey[9] as number | null | undefined,       context.queryKey[10] as number | null | undefined,       context.queryKey[11] as string | null | undefined,       context.queryKey[12] as Types.SortOrder | undefined    );
}

export function useGetIssuesForStudyQuery<TSelectData = Types.PagedResultOfIssueDto, TError = unknown>(dto: GetIssuesForStudyIssueQueryParameters, options?: UseQueryOptions<Types.PagedResultOfIssueDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets all issues for study
 * @param patientUniqId (optional) Filter issues by the patient unique Id
 * @param patientUniqIds (optional) Filter issues by the patient unique Id
 * @param state (optional) Filter issues by state
 * @param subjectList (optional) Filter issues by subject
 * @param patientGroupIds (optional) Filter issues by linked patient group
 * @param isNew (optional) Filter issues by IsNew field
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetIssuesForStudyQuery<TSelectData = Types.PagedResultOfIssueDto, TError = unknown>(studyId: number, patientUniqId?: string | null | undefined, patientUniqIds?: string[] | null | undefined, state?: Types.IssuesStateEnum | null | undefined, subjectList?: string[] | null | undefined, patientGroupIds?: number[] | null | undefined, isNew?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: UseQueryOptions<Types.PagedResultOfIssueDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetIssuesForStudyQuery<TSelectData = Types.PagedResultOfIssueDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfIssueDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  let patientUniqId: any = undefined;
  let patientUniqIds: any = undefined;
  let state: any = undefined;
  let subjectList: any = undefined;
  let patientGroupIds: any = undefined;
  let isNew: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId, patientUniqId, patientUniqIds, state, subjectList, patientGroupIds, isNew, offset, limit, sortBy, sortOrder,  } = params[0] as GetIssuesForStudyIssueQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, patientUniqId, patientUniqIds, state, subjectList, patientGroupIds, isNew, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.PagedResultOfIssueDto, TError, TSelectData>({
    queryFn: __getIssuesForStudy,
    queryKey: getIssuesForStudyQueryKey(studyId, patientUniqId, patientUniqIds, state, subjectList, patientGroupIds, isNew, offset, limit, sortBy, sortOrder),
    ...getIssuesForStudyDefaultOptions as unknown as UseQueryOptions<Types.PagedResultOfIssueDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Gets all issues for study
 * @param patientUniqId (optional) Filter issues by the patient unique Id
 * @param patientUniqIds (optional) Filter issues by the patient unique Id
 * @param state (optional) Filter issues by state
 * @param subjectList (optional) Filter issues by subject
 * @param patientGroupIds (optional) Filter issues by linked patient group
 * @param isNew (optional) Filter issues by IsNew field
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetIssuesForStudyData(queryClient: QueryClient, updater: (data: Types.PagedResultOfIssueDto | undefined) => Types.PagedResultOfIssueDto, studyId: number, patientUniqId?: string | null | undefined, patientUniqIds?: string[] | null | undefined, state?: Types.IssuesStateEnum | null | undefined, subjectList?: string[] | null | undefined, patientGroupIds?: number[] | null | undefined, isNew?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getIssuesForStudyQueryKey(studyId, patientUniqId, patientUniqIds, state, subjectList, patientGroupIds, isNew, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Gets all issues for study
 * @param patientUniqId (optional) Filter issues by the patient unique Id
 * @param patientUniqIds (optional) Filter issues by the patient unique Id
 * @param state (optional) Filter issues by state
 * @param subjectList (optional) Filter issues by subject
 * @param patientGroupIds (optional) Filter issues by linked patient group
 * @param isNew (optional) Filter issues by IsNew field
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetIssuesForStudyDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfIssueDto | undefined) => Types.PagedResultOfIssueDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getIssuesGroupedByPatientsUrl(studyId: number, patientUniqId?: string | null | undefined, patientUniqIds?: string[] | null | undefined, state?: Types.IssuesStateEnum | null | undefined, subjectList?: string[] | null | undefined, patientGroupIds?: number[] | null | undefined, isNew?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/issues/groupedByPatients?";
  if (studyId === undefined || studyId === null)
    throw new Error("The parameter 'studyId' must be defined and cannot be null.");
  else
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
if (patientUniqId !== undefined && patientUniqId !== null)
    url_ += "PatientUniqId=" + encodeURIComponent("" + patientUniqId) + "&";
if (patientUniqIds !== undefined && patientUniqIds !== null)
    patientUniqIds && patientUniqIds.forEach(item => { url_ += "PatientUniqIds=" + encodeURIComponent("" + item) + "&"; });
if (state !== undefined && state !== null)
    url_ += "State=" + encodeURIComponent("" + state) + "&";
if (subjectList !== undefined && subjectList !== null)
    subjectList && subjectList.forEach(item => { url_ += "SubjectList=" + encodeURIComponent("" + item) + "&"; });
if (patientGroupIds !== undefined && patientGroupIds !== null)
    patientGroupIds && patientGroupIds.forEach(item => { url_ += "PatientGroupIds=" + encodeURIComponent("" + item) + "&"; });
if (isNew !== undefined && isNew !== null)
    url_ += "IsNew=" + encodeURIComponent("" + isNew) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getIssuesGroupedByPatientsDefaultOptions: UseQueryOptions<Types.PagedResultOfGroupedIssueDto, unknown, Types.PagedResultOfGroupedIssueDto> = {
  queryFn: __getIssuesGroupedByPatients,
};
export function getGetIssuesGroupedByPatientsDefaultOptions(): UseQueryOptions<Types.PagedResultOfGroupedIssueDto, unknown, Types.PagedResultOfGroupedIssueDto> {
  return getIssuesGroupedByPatientsDefaultOptions;
};
export function setGetIssuesGroupedByPatientsDefaultOptions(options: UseQueryOptions<Types.PagedResultOfGroupedIssueDto, unknown, Types.PagedResultOfGroupedIssueDto>) {
  getIssuesGroupedByPatientsDefaultOptions = options;
}

export function getIssuesGroupedByPatientsQueryKey(dto: GetIssuesGroupedByPatientsIssueQueryParameters): QueryKey;
export function getIssuesGroupedByPatientsQueryKey(studyId: number, patientUniqId?: string | null | undefined, patientUniqIds?: string[] | null | undefined, state?: Types.IssuesStateEnum | null | undefined, subjectList?: string[] | null | undefined, patientGroupIds?: number[] | null | undefined, isNew?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getIssuesGroupedByPatientsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId, patientUniqId, patientUniqIds, state, subjectList, patientGroupIds, isNew, offset, limit, sortBy, sortOrder,  } = params[0] as GetIssuesGroupedByPatientsIssueQueryParameters;

    return trimArrayEnd([
        'IssueClient',
        'getIssuesGroupedByPatients',
        studyId as any,
        patientUniqId as any,
        patientUniqIds as any,
        state as any,
        subjectList as any,
        patientGroupIds as any,
        isNew as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'IssueClient',
        'getIssuesGroupedByPatients',
        ...params
      ]);
  }
}
function __getIssuesGroupedByPatients(context: QueryFunctionContext) {
  return Client.getIssuesGroupedByPatients(
      context.queryKey[2] as number,       context.queryKey[3] as string | null | undefined,       context.queryKey[4] as string[] | null | undefined,       context.queryKey[5] as Types.IssuesStateEnum | null | undefined,       context.queryKey[6] as string[] | null | undefined,       context.queryKey[7] as number[] | null | undefined,       context.queryKey[8] as boolean | null | undefined,       context.queryKey[9] as number | null | undefined,       context.queryKey[10] as number | null | undefined,       context.queryKey[11] as string | null | undefined,       context.queryKey[12] as Types.SortOrder | undefined    );
}

export function useGetIssuesGroupedByPatientsQuery<TSelectData = Types.PagedResultOfGroupedIssueDto, TError = unknown>(dto: GetIssuesGroupedByPatientsIssueQueryParameters, options?: UseQueryOptions<Types.PagedResultOfGroupedIssueDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets issues grouped by patients
 * @param patientUniqId (optional) Filter issues by the patient unique Id
 * @param patientUniqIds (optional) Filter issues by the patient unique Id
 * @param state (optional) Filter issues by state
 * @param subjectList (optional) Filter issues by subject
 * @param patientGroupIds (optional) Filter issues by linked patient group
 * @param isNew (optional) Filter issues by IsNew field
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetIssuesGroupedByPatientsQuery<TSelectData = Types.PagedResultOfGroupedIssueDto, TError = unknown>(studyId: number, patientUniqId?: string | null | undefined, patientUniqIds?: string[] | null | undefined, state?: Types.IssuesStateEnum | null | undefined, subjectList?: string[] | null | undefined, patientGroupIds?: number[] | null | undefined, isNew?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: UseQueryOptions<Types.PagedResultOfGroupedIssueDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetIssuesGroupedByPatientsQuery<TSelectData = Types.PagedResultOfGroupedIssueDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfGroupedIssueDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  let patientUniqId: any = undefined;
  let patientUniqIds: any = undefined;
  let state: any = undefined;
  let subjectList: any = undefined;
  let patientGroupIds: any = undefined;
  let isNew: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId, patientUniqId, patientUniqIds, state, subjectList, patientGroupIds, isNew, offset, limit, sortBy, sortOrder,  } = params[0] as GetIssuesGroupedByPatientsIssueQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, patientUniqId, patientUniqIds, state, subjectList, patientGroupIds, isNew, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.PagedResultOfGroupedIssueDto, TError, TSelectData>({
    queryFn: __getIssuesGroupedByPatients,
    queryKey: getIssuesGroupedByPatientsQueryKey(studyId, patientUniqId, patientUniqIds, state, subjectList, patientGroupIds, isNew, offset, limit, sortBy, sortOrder),
    ...getIssuesGroupedByPatientsDefaultOptions as unknown as UseQueryOptions<Types.PagedResultOfGroupedIssueDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Gets issues grouped by patients
 * @param patientUniqId (optional) Filter issues by the patient unique Id
 * @param patientUniqIds (optional) Filter issues by the patient unique Id
 * @param state (optional) Filter issues by state
 * @param subjectList (optional) Filter issues by subject
 * @param patientGroupIds (optional) Filter issues by linked patient group
 * @param isNew (optional) Filter issues by IsNew field
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetIssuesGroupedByPatientsData(queryClient: QueryClient, updater: (data: Types.PagedResultOfGroupedIssueDto | undefined) => Types.PagedResultOfGroupedIssueDto, studyId: number, patientUniqId?: string | null | undefined, patientUniqIds?: string[] | null | undefined, state?: Types.IssuesStateEnum | null | undefined, subjectList?: string[] | null | undefined, patientGroupIds?: number[] | null | undefined, isNew?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getIssuesGroupedByPatientsQueryKey(studyId, patientUniqId, patientUniqIds, state, subjectList, patientGroupIds, isNew, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Gets issues grouped by patients
 * @param patientUniqId (optional) Filter issues by the patient unique Id
 * @param patientUniqIds (optional) Filter issues by the patient unique Id
 * @param state (optional) Filter issues by state
 * @param subjectList (optional) Filter issues by subject
 * @param patientGroupIds (optional) Filter issues by linked patient group
 * @param isNew (optional) Filter issues by IsNew field
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetIssuesGroupedByPatientsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfGroupedIssueDto | undefined) => Types.PagedResultOfGroupedIssueDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function addIssueUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/issues?";
  if (studyId === undefined || studyId === null)
    throw new Error("The parameter 'studyId' must be defined and cannot be null.");
  else
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function addIssueMutationKey(studyId: number): MutationKey {
  return trimArrayEnd([
      'IssueClient',
      'addIssue',
      studyId as any,
    ]);
}

/**
 * Create new issue
 * @param subject (optional) 
 * @param topic (optional) 
 * @param topicAdditional (optional) 
 * @param description (optional) 
 * @param resultId (optional) 
 * @param fieldId (optional) 
 * @param stepName (optional) 
 * @param fieldDescription (optional) 
 * @param deadlineAt (optional) 
 * @param linkedPatientUniqId (optional) 
 * @param files (optional) 
 * @param recommendedAction (optional) 
 */
export function useAddIssueMutation<TContext>(studyId: number, options?: Omit<UseMutationOptions<Types.IssueDto, unknown, AddIssueIssueMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.IssueDto, unknown, AddIssueIssueMutationParameters, TContext> {
  const key = addIssueMutationKey(studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((addIssueIssueMutationParameters: AddIssueIssueMutationParameters) => Client.addIssue(studyId, addIssueIssueMutationParameters.subject, addIssueIssueMutationParameters.topic, addIssueIssueMutationParameters.topicAdditional, addIssueIssueMutationParameters.description, addIssueIssueMutationParameters.resultId, addIssueIssueMutationParameters.fieldId, addIssueIssueMutationParameters.stepName, addIssueIssueMutationParameters.fieldDescription, addIssueIssueMutationParameters.deadlineAt, addIssueIssueMutationParameters.linkedPatientUniqId, addIssueIssueMutationParameters.files, addIssueIssueMutationParameters.recommendedAction), {...options, mutationKey: key});
}
  
    
export function performIssueOperationUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/issues/{id}/performOperation";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function performIssueOperationMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'IssueClient',
      'performIssueOperation',
      id as any,
    ]);
}

/**
 * Perform issue operation
 */
export function usePerformIssueOperationMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.IssueDto, unknown, Types.PerformIssueOperationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.IssueDto, unknown, Types.PerformIssueOperationDto, TContext> {
  const key = performIssueOperationMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.PerformIssueOperationDto) => Client.performIssueOperation(id, dto), {...options, mutationKey: key});
}
  
    
export function removeIssueOperationUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/issues/operation/{id}/revert";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeIssueOperationMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'IssueClient',
      'removeIssueOperation',
      id as any,
    ]);
}

/**
 * Remove issue operation
 */
export function useRemoveIssueOperationMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeIssueOperationMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.removeIssueOperation(id), {...options, mutationKey: key});
}
  
    
export function resumeIssueOperationUrl(id: number, newState: Types.IssueOperationStateEnum, rejectComment?: string | null | undefined): string {
  let url_ = getBaseUrl() + "/api/issues/operation/{id}/resume?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  if (newState === undefined || newState === null)
    throw new Error("The parameter 'newState' must be defined and cannot be null.");
  else
    url_ += "newState=" + encodeURIComponent("" + newState) + "&";
if (rejectComment !== undefined && rejectComment !== null)
    url_ += "rejectComment=" + encodeURIComponent("" + rejectComment) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function resumeIssueOperationMutationKey(id: number, newState: Types.IssueOperationStateEnum, rejectComment?: string | null | undefined): MutationKey {
  return trimArrayEnd([
      'IssueClient',
      'resumeIssueOperation',
      id as any,
      newState as any,
      rejectComment as any,
    ]);
}

/**
 * Change issue operation state
 * @param rejectComment (optional) 
 */
export function useResumeIssueOperationMutation<TContext>(id: number, newState: Types.IssueOperationStateEnum, rejectComment?: string | null | undefined, options?: Omit<UseMutationOptions<Types.IssueOperationDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.IssueOperationDto, unknown, void, TContext> {
  const key = resumeIssueOperationMutationKey(id, newState, rejectComment);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.resumeIssueOperation(id, newState, rejectComment), {...options, mutationKey: key});
}
  
    
export function checkIssueUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/issues/{id}/check";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function checkIssueMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'IssueClient',
      'checkIssue',
      id as any,
    ]);
}

/**
 * Check the issue
 */
export function useCheckIssueMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = checkIssueMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.checkIssue(id), {...options, mutationKey: key});
}
  
    
export function getIssueHistoryUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/issues/{id}/history";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getIssueHistoryDefaultOptions: UseQueryOptions<Types.IssueHistoryDto, unknown, Types.IssueHistoryDto> = {
  queryFn: __getIssueHistory,
};
export function getGetIssueHistoryDefaultOptions(): UseQueryOptions<Types.IssueHistoryDto, unknown, Types.IssueHistoryDto> {
  return getIssueHistoryDefaultOptions;
};
export function setGetIssueHistoryDefaultOptions(options: UseQueryOptions<Types.IssueHistoryDto, unknown, Types.IssueHistoryDto>) {
  getIssueHistoryDefaultOptions = options;
}

export function getIssueHistoryQueryKey(id: number): QueryKey;
export function getIssueHistoryQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetIssueHistoryIssueQueryParameters;

    return trimArrayEnd([
        'IssueClient',
        'getIssueHistory',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'IssueClient',
        'getIssueHistory',
        ...params
      ]);
  }
}
function __getIssueHistory(context: QueryFunctionContext) {
  return Client.getIssueHistory(
      context.queryKey[2] as number    );
}

export function useGetIssueHistoryQuery<TSelectData = Types.IssueHistoryDto, TError = unknown>(dto: GetIssueHistoryIssueQueryParameters, options?: UseQueryOptions<Types.IssueHistoryDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get issue history by Id
 */
export function useGetIssueHistoryQuery<TSelectData = Types.IssueHistoryDto, TError = unknown>(id: number, options?: UseQueryOptions<Types.IssueHistoryDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetIssueHistoryQuery<TSelectData = Types.IssueHistoryDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.IssueHistoryDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetIssueHistoryIssueQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.IssueHistoryDto, TError, TSelectData>({
    queryFn: __getIssueHistory,
    queryKey: getIssueHistoryQueryKey(id),
    ...getIssueHistoryDefaultOptions as unknown as UseQueryOptions<Types.IssueHistoryDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Get issue history by Id
 */
export function setGetIssueHistoryData(queryClient: QueryClient, updater: (data: Types.IssueHistoryDto | undefined) => Types.IssueHistoryDto, id: number) {
  queryClient.setQueryData(getIssueHistoryQueryKey(id),
    updater
  );
}

/**
 * Get issue history by Id
 */
export function setGetIssueHistoryDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.IssueHistoryDto | undefined) => Types.IssueHistoryDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getIssueCommentsUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/issues/{id}/comments";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getIssueCommentsDefaultOptions: UseQueryOptions<Types.IssueCommentDto[], unknown, Types.IssueCommentDto[]> = {
  queryFn: __getIssueComments,
};
export function getGetIssueCommentsDefaultOptions(): UseQueryOptions<Types.IssueCommentDto[], unknown, Types.IssueCommentDto[]> {
  return getIssueCommentsDefaultOptions;
};
export function setGetIssueCommentsDefaultOptions(options: UseQueryOptions<Types.IssueCommentDto[], unknown, Types.IssueCommentDto[]>) {
  getIssueCommentsDefaultOptions = options;
}

export function getIssueCommentsQueryKey(id: number): QueryKey;
export function getIssueCommentsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetIssueCommentsIssueQueryParameters;

    return trimArrayEnd([
        'IssueClient',
        'getIssueComments',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'IssueClient',
        'getIssueComments',
        ...params
      ]);
  }
}
function __getIssueComments(context: QueryFunctionContext) {
  return Client.getIssueComments(
      context.queryKey[2] as number    );
}

export function useGetIssueCommentsQuery<TSelectData = Types.IssueCommentDto[], TError = unknown>(dto: GetIssueCommentsIssueQueryParameters, options?: UseQueryOptions<Types.IssueCommentDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get issue comments
 */
export function useGetIssueCommentsQuery<TSelectData = Types.IssueCommentDto[], TError = unknown>(id: number, options?: UseQueryOptions<Types.IssueCommentDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetIssueCommentsQuery<TSelectData = Types.IssueCommentDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.IssueCommentDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetIssueCommentsIssueQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.IssueCommentDto[], TError, TSelectData>({
    queryFn: __getIssueComments,
    queryKey: getIssueCommentsQueryKey(id),
    ...getIssueCommentsDefaultOptions as unknown as UseQueryOptions<Types.IssueCommentDto[], TError, TSelectData>,
    ...options,
  });
}
/**
 * Get issue comments
 */
export function setGetIssueCommentsData(queryClient: QueryClient, updater: (data: Types.IssueCommentDto[] | undefined) => Types.IssueCommentDto[], id: number) {
  queryClient.setQueryData(getIssueCommentsQueryKey(id),
    updater
  );
}

/**
 * Get issue comments
 */
export function setGetIssueCommentsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.IssueCommentDto[] | undefined) => Types.IssueCommentDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function addIssueCommentUrl(id: number, message: string): string {
  let url_ = getBaseUrl() + "/api/issues/{id}/comment?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  if (message === undefined || message === null)
    throw new Error("The parameter 'message' must be defined and cannot be null.");
  else
    url_ += "message=" + encodeURIComponent("" + message) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function addIssueCommentMutationKey(id: number, message: string): MutationKey {
  return trimArrayEnd([
      'IssueClient',
      'addIssueComment',
      id as any,
      message as any,
    ]);
}

/**
 * Add comment to the issue
 */
export function useAddIssueCommentMutation<TContext>(id: number, message: string, options?: Omit<UseMutationOptions<Types.IssueCommentDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.IssueCommentDto, unknown, void, TContext> {
  const key = addIssueCommentMutationKey(id, message);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.addIssueComment(id, message), {...options, mutationKey: key});
}
  
    
export function removeIssueCommentUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/issues/comments/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeIssueCommentMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'IssueClient',
      'removeIssueComment',
      id as any,
    ]);
}

/**
 * Remove issue comment
 */
export function useRemoveIssueCommentMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeIssueCommentMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.removeIssueComment(id), {...options, mutationKey: key});
}